// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3-xlV","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__MobuM"};